export interface StoreInfo {
  email: string
  hoursWeekdays: string
  hoursSunday: string
  deliveryArea: string
  slogan: string
}

export const STORE_INFO: StoreInfo = {
  email: 'moraiskaua03@gmail.com',
  hoursWeekdays: 'Seg–Sáb 10h–22h',
  hoursSunday: 'Dom 10h–22h',
  deliveryArea: 'toda a cidade',
  slogan: 'O que você sente, em flor.',
}
